export default __webpack_public_path__ + "static/media/ct3.1.4edd9b7c.png";